<template>
  <div class="register">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>Forget Password</span>
      </div>
      <el-form :model="retrieveForm" status-icon :rules="registerRules" ref="retrieveFormRef">
        <el-form-item prop="email">
          <el-input placeholder="Email" v-model="retrieveForm.email" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item prop="newPassword">
          <el-input type="password" placeholder="new password" v-model="retrieveForm.newPassword"></el-input>
        </el-form-item>

        <el-form-item prop="newPassword1">
          <el-input
            type="password"
            placeholder="confirm new password"
            v-model="retrieveForm.newPassword1"
          ></el-input>
        </el-form-item>


           <!-- 随机验证码 -->
          <el-form-item prop="verfiyCode" class="vcode" v-if="ipCount>3">
            <el-input
              v-model="retrieveForm.verfiyCode"
              prefix-icon="iconfont icon-yanzhengma"
              type="captcha"
              placeholder="Verification code"
            ></el-input>
            <img :src="imgSrc" @click="changeVcode" />
          </el-form-item>

        <el-form-item prop="captcha" class="vcode" ref="captchaRef">
          <el-input placeholder="captcha" v-model="retrieveForm.captcha"></el-input>
          <el-button plain @click="getCaptcha" type="primary" :loading="sending">{{btnTxt}}</el-button>
        </el-form-item>

        <el-form-item class="btnList">
          <div>
            <el-button type="primary" @click="retrievePass('retrieveFormRef')">Complete</el-button>
            <el-button @click="resetForm('retrieveFormRef')">Reset</el-button>
          </div>
          <el-button @click="backToLogin"  icon="el-icon-back">Return to Login</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    var validatorEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Email can not be empty'))
      }
      callback()
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter your password'))
      } else {
        if (this.retrieveForm.newPassword !== '') {
          callback()
        }
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter your password again'))
      } else if (value !== this.retrieveForm.newPassword) {
        callback(new Error('Inconsistent passwords'))
      } else {
        callback()
      }
    }
    return {
      sending:false,
      btnTxt:'Get Captcha',
      retrieveForm: {
        // 验证码
        captcha: '',
        // 邮箱
        email: '',
        // 是否已经发送过邮件
        isSendEmail: 0,
        // 新密码
        newPassword: '',
        // 确认新密码
        newPassword1: '',
      },
      a:null,
      ipCount:0,
      imgSrc:null,
      // 注册表单验证规则
      registerRules: {
        email: [
          {
            required: true,
            message: 'Please enter email address',
            trigger: 'blur',
          },
          {
            type: 'email',
            message: 'Please enter the correct email address',
            trigger: ['blur', 'change'],
          },
        ],

        captcha: [
          {
            required: true,
            message: 'Please enter the captcha',
            trigger: 'blur',
          },
        ],

        newPassword: [{ validator: validatePass, trigger: 'blur' }],
        newPassword1: [{ validator: validatePass2, trigger: 'blur' }],
      },
    }
  },
  methods: {
      // 点击切换验证码
    changeVcode() {
      this.getVcode()
    },
    async getVcode() {
      let params = {
        oldKey: this.retrieveForm.verfiyCodeKey,
      }

      // 获取登录的验证码 进行用户判断
      this.$get('auth/getCaptchaBase64', { params }).then(({ data: res1 }) => {
        this.imgSrc = 'data:image/jpeg;base64,' + res1.base64String
        this.retrieveForm.verfiyCodeKey = res1.key
      })
    },
    // 返回到登录页
    backToLogin() {
      this.$router.go(-1)
    },
    // 获取验证码
    getCaptcha() {
      if (!this.retrieveForm.email){
        return this.$message.warning('Please enter email address')
      }
      if (this.ipCount>3){
        if(!this.retrieveForm.verfiyCode){
            return this.$message.warning('Please enter verification code')
        }
        
      }

        this.sending=true
        this.btnTxt='Sending...'
      this.$post('auth/sendCaptchaEmail', this.retrieveForm).then(
        ({ data: res }) => {
          if (! res.ok ) {
            this. setEnable();
            return this.$message.error(res.msg)
          }
          this.setDisable()
          //重新计算IP发送次数
          this.getIpCount()
          this.$message.success(res.msg)
        }
      )
    },
    setDisable(){
       this.sending = true;
        let langtime =60;
        let than=this
      this.a=setInterval(function() {
          if (langtime == 0) {
            than.sending = false;
            than.btnTxt = "Get Captcha";
            clearInterval(this.a);
          } else {
            langtime--;
            than.btnTxt = ` ${langtime} s`;
          }
        }, 1000)
    },
    setEnable(){
       this.sending = false;
        this.btnTxt = "Get Captcha";
        clearInterval(this.a);
    },
      

    // 注册
    retrievePass(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return
        this.$post('auth/resetMyPwd', this.retrieveForm).then(
          ({ data: res }) => {
            if (!res.ok) return this.$message.error(res.msg)
            this.$message.success(res.msg)
            this.$router.push('/login')
          }
        )
      })
    },
   
    getIpCount() {
      this.$get('auth/countForgetEmail').then(
          ({ data: res }) => {
            console.log(res)
            if (res.ok) {
              this.ipCount = res.data
              //本IP获取邮件验证码超过3次，则需要随机验证码，以免被恶意攻击
              if(this.ipCount>3){
                
                this.changeVcode()
              }
            }
            
          }
        )
    },

    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
  created() {

    
    this.getIpCount();

  },
}
</script>

<style lang="less" scoped>
.register {
  height: 100%;
  width: 100%;
  overflow: hidden;
  // background: url(../assets/banner/rifo1.png) no-repeat;
  background-size: 100% 100%;
  // width: 30vw;
  .el-card {
    width: 550px;
    margin: 200px auto 0;
    // background: rgba(0, 0, 0, 0.1);
    border: 1px solid #ddd;
    .clearfix {
      font-size: 26px;
      font-weight: bold;
      color: #397EF5;
    }
  }
  .el-form {
    margin: 0 auto;
  }
}
/deep/.el-card__header {
  border: none;
  text-align: center;
}

.login_form {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}
.vcode {
  display: flex;
  justify-content: space-around;
  img {
    height: 40px;
    width: 100px;
    margin-left: 5px;
    border-radius: 2px;
    border: 1px solid #e2e4ea;
    box-sizing: border-box;
  }
  /deep/.el-form-item__content {
    flex: 1;
    display: flex;
    justify-content: space-between;
  }
}
.btnList {
  /deep/.el-form-item__content {
    display: flex;
    justify-content: space-between;
    div {
      width: 100%;
    }
  }
}
</style>